export const PP_REQUIRED_GROUPS = ["PUBLISHER", "PPCREATE", "PPREAD", "PPUPDATE"]
export const MO_REQUIRED_GROUPS = ["NCREATE", "NCONFIRM", "NUPDATE"]
export const MMiA_REQUIRED_GROUPS = ["MMiAANNREPUSER"]
